"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationStepAction = exports.AuthorizationStepStatus = exports.AuthorizedAction = void 0;
// Action to perfom after authorization step is finished
var AuthorizedAction;
(function (AuthorizedAction) {
    AuthorizedAction["BID"] = "bid";
    AuthorizedAction["BUY"] = "buy";
    AuthorizedAction["MINT"] = "mint";
    AuthorizedAction["RENT"] = "rent";
    AuthorizedAction["CLAIM_NAME"] = "claim_name";
    AuthorizedAction["SWAP_MANA"] = "swap_mana";
    AuthorizedAction["SELL"] = "sell";
    AuthorizedAction["PUBLISH_COLLECTION"] = "publish_collection";
})(AuthorizedAction = exports.AuthorizedAction || (exports.AuthorizedAction = {}));
var AuthorizationStepStatus;
(function (AuthorizationStepStatus) {
    AuthorizationStepStatus["LOADING_INFO"] = "loading_info";
    AuthorizationStepStatus["PENDING"] = "pending";
    AuthorizationStepStatus["WAITING"] = "waiting";
    AuthorizationStepStatus["PROCESSING"] = "processing";
    AuthorizationStepStatus["ALLOWANCE_AMOUNT_ERROR"] = "allowance_amount_error";
    AuthorizationStepStatus["ERROR"] = "error";
    AuthorizationStepStatus["DONE"] = "done";
})(AuthorizationStepStatus = exports.AuthorizationStepStatus || (exports.AuthorizationStepStatus = {}));
var AuthorizationStepAction;
(function (AuthorizationStepAction) {
    AuthorizationStepAction["REVOKE"] = "revoke";
    AuthorizationStepAction["GRANT"] = "grant";
    AuthorizationStepAction["CONFIRM"] = "confirm";
})(AuthorizationStepAction = exports.AuthorizationStepAction || (exports.AuthorizationStepAction = {}));
//# sourceMappingURL=AuthorizationModal.types.js.map